export default __webpack_public_path__ + "static/media/email.b9914af6.jpg";